import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconVisaIssues: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 58 58" name="visa-issues">
    <rect
      x="0.418619"
      y="0.5694"
      width="39.1132"
      height="49.8764"
      transform="matrix(0.988636 0.150327 -0.151398 0.988473 13.1134 0.783722)"
      fill="url(#paint0_linear_5408_2580)"
      stroke="url(#paint1_linear_5408_2580)"
    />
    <path d="M9.57495 4.47388H49.6915V55.346H9.57495V4.47388Z" fill="url(#paint2_linear_5408_2580)" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.0515 5.11388H10.215V54.706H49.0515V5.11388ZM9.57495 4.47388V55.346H49.6915V4.47388H9.57495Z"
      fill="url(#paint3_linear_5408_2580)"
    />
    <g style={{ mixBlendMode: 'multiply' }} opacity="0.6">
      <path
        d="M29.8378 10.5315C29.8378 10.5906 29.7899 10.6386 29.7307 10.6386H12.6146C12.5554 10.6386 12.5074 10.5906 12.5074 10.5315C12.5074 10.4723 12.5554 10.4243 12.6146 10.4243H29.7307C29.7899 10.4243 29.8378 10.4723 29.8378 10.5315ZM24.8553 13.5241C24.8553 13.5833 24.8073 13.6312 24.7481 13.6312H12.6146C12.5554 13.6312 12.5074 13.5833 12.5074 13.5241C12.5074 13.4649 12.5554 13.4169 12.6146 13.4169H24.7481C24.8073 13.4169 24.8553 13.4649 24.8553 13.5241ZM12.6146 19.0999C12.5554 19.0999 12.5074 19.0519 12.5074 18.9928C12.5074 18.9336 12.5554 18.8856 12.6146 18.8856H44.1716C44.2308 18.8856 44.2788 18.9336 44.2788 18.9928C44.2788 19.0519 44.2308 19.0999 44.1716 19.0999H12.6146ZM44.2788 31.427C44.2788 31.4861 44.2308 31.5341 44.1716 31.5341H12.6146C12.5554 31.5341 12.5074 31.4861 12.5074 31.427C12.5074 31.3678 12.5554 31.3198 12.6146 31.3198H44.1716C44.2308 31.3198 44.2788 31.3678 44.2788 31.427ZM12.6146 22.6084C12.5554 22.6084 12.5074 22.5605 12.5074 22.5013C12.5074 22.4421 12.5554 22.3942 12.6146 22.3942H44.1716C44.2308 22.3942 44.2788 22.4421 44.2788 22.5013C44.2788 22.5605 44.2308 22.6084 44.1716 22.6084H12.6146ZM44.2788 34.9348C44.2788 34.994 44.2308 35.0419 44.1716 35.0419H12.6146C12.5554 35.0419 12.5074 34.994 12.5074 34.9348C12.5074 34.8756 12.5554 34.8276 12.6146 34.8276H44.1716C44.2308 34.8276 44.2788 34.8756 44.2788 34.9348ZM12.6146 26.1164C12.5554 26.1164 12.5074 26.0684 12.5074 26.0092C12.5074 25.9501 12.5554 25.9021 12.6146 25.9021H44.1716C44.2308 25.9021 44.2788 25.9501 44.2788 26.0092C44.2788 26.0684 44.2308 26.1164 44.1716 26.1164H12.6146ZM44.2788 38.4433C44.2788 38.5025 44.2308 38.5504 44.1716 38.5504H12.6146C12.5554 38.5504 12.5074 38.5025 12.5074 38.4433C12.5074 38.3841 12.5554 38.3361 12.6146 38.3361H44.1716C44.2308 38.3361 44.2788 38.3841 44.2788 38.4433ZM12.6146 42.1786C12.5554 42.1786 12.5074 42.1307 12.5074 42.0715C12.5074 42.0123 12.5554 41.9643 12.6146 41.9643H29.7307C29.7899 41.9643 29.8378 42.0123 29.8378 42.0715C29.8378 42.1307 29.7899 42.1786 29.7307 42.1786H12.6146Z"
        stroke="#F1C4D7"
      />
    </g>
    <g style={{ mixBlendMode: 'multiply' }} opacity="0.9">
      <path
        d="M15.9589 47.7255L15.9684 47.7185L16.0884 47.6298L15.9589 47.7255ZM15.9589 47.7255C15.9589 47.7255 15.9589 47.7255 15.9589 47.7255L15.9684 47.7185L15.9589 47.7255ZM18.222 48.3741L18.2051 48.3966L18.1588 48.4583M18.222 48.3741L18.1588 48.4583M18.222 48.3741L18.2051 48.3966L18.1588 48.4583M18.222 48.3741L17.923 48.7721L18.1588 48.4583M18.1588 48.4583L18.1588 48.4583M18.1588 48.4583L18.1588 48.4583M15.9764 48.6171C15.9408 48.6213 15.905 48.626 15.8693 48.6311C15.8862 48.5724 15.8952 48.5121 15.8966 48.4519C15.9033 48.4505 15.91 48.4489 15.9167 48.4472C15.9225 48.4706 15.9292 48.4938 15.9368 48.5167C15.9477 48.5498 15.9608 48.5834 15.9764 48.6171ZM15.1366 47.0026L15.3618 47.0916L15.1366 47.0026ZM24.4075 48.5767L24.4278 48.8046L24.387 48.3452L24.4075 48.5767Z"
        stroke="#E7A3BF"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.5094 4.50568H38.9253H38.4572C38.543 4.36756 38.878 4.19077 39.11 4.1521H39.5094C40.1925 4.1521 40.7462 4.86446 40.7462 5.74319V10.1629C40.7462 10.9928 40.2232 11.6656 39.5781 11.6656C38.9329 11.6656 38.4099 10.9928 38.4099 10.1629V7.90884H38.6848V10.1629C38.6848 10.7975 39.0847 11.312 39.5781 11.312C40.0714 11.312 40.4714 10.7975 40.4714 10.1629V5.74319C40.4714 5.05973 40.0407 4.50568 39.5094 4.50568Z"
      fill="url(#paint4_linear_5408_2580)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5408_2580"
        x1="53.7882"
        y1="43.9112"
        x2="-17.7501"
        y2="-9.92902"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE3EF" />
        <stop offset="0.0001" stopColor="#F8ACE2" />
        <stop offset="1" stopColor="#E59DFE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5408_2580"
        x1="45.039"
        y1="55.5417"
        x2="27.4252"
        y2="29.2898"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E496FF" />
        <stop offset="1" stopColor="#E496FF" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5408_2580"
        x1="3.69745"
        y1="4.47388"
        x2="42.9531"
        y2="59.8831"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFEEF5" />
        <stop offset="1" stopColor="#F7B5E4" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5408_2580"
        x1="51.5374"
        y1="57.969"
        x2="9.57495"
        y2="0.528954"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00970882" stopColor="#E496FF" />
        <stop offset="0.424714" stopColor="#FFC2E3" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_5408_2580"
        x1="38.4928"
        y1="8.88461"
        x2="40.9616"
        y2="8.88461"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#283470" />
        <stop offset="1" stopColor="#404680" />
      </linearGradient>
    </defs>
  </Icon>
);
